// import echarts from 'echarts'
import api from '../api'
const echarts = require('echarts')

let colors = [
  '#c23531',
  '#2f4554',
  '#61a0a8',
  '#d48265',
  '#91c7ae',

  '#B5C334',
  '#FCCE10',
  '#E87C25',
  '#27727B',

  '#FE8463',
  '#9BCA63',
  '#FAD860',
  '#F3A43B',
  '#60C0DD',

  '#D7504B',
  '#C6E579',
  '#F4E001',
  '#F0805A',
  '#26C0C0'
]

function lineBar(r, domId, domTitle, tooltipOptions, labelOptions) {
  var option = {
    color: colors,
    backgroundColor: {
      image: document.getElementById('waterMarkImg'),
      repeat: 'repeat'
    },
    title: {
      text: '',
      left: 'center',
      textStyle: {
        fontSize: 14
      }
    },
    legend: {
      data: [],
      bottom: 42
    },
    tooltip: {
      trigger: 'axis',
      textStyle: {
        fontSize: 12
      }
    },
    grid: {
      left: '3%',
      right: '4%',
      top: 40,
      bottom: '12%',
      containLabel: true
    },
    xAxis: [
      {
        type: 'category',
        data: [],
        axisPointer: {
          type: 'shadow'
        },
        axisLabel: {
          rotate: 70
        }
      }
    ],
    yAxis: [
      {
        type: 'value',
        name: '',
        axisLabel: {
          formatter: '{value}'
        }
      },
      {
        type: 'value',
        name: '',
        axisLabel: {
          formatter: '{value}'
        },
        splitLine: {
          show: false
        }
      }
    ],
    label: {
      show: true,
      position: 'top'
    },
    series: [],
    dataZoom: [
      { show: true, realtime: true, start: 0, end: 100 },
      { type: 'inside', realtime: true, start: 0, end: 100 }
    ]
  }

  option.title.text = domTitle
  option.series = r.series
  option.xAxis[0].data = r.xAxis
  var myChart1 = echarts.getInstanceByDom(document.getElementById(domId))
  if (myChart1) myChart1.dispose()
  var myChart = echarts.init(document.getElementById(domId))

  if (tooltipOptions) {
    option.tooltip.formatter = tooltipOptions.formatter
  }
  if (labelOptions) {
    if (labelOptions.show !== undefined) {
      option.label.show = labelOptions.show
      if (!labelOptions.show) {
        for (let item in r.series) {
          r.series[item].symbol = 'none'
        }
      }
    }
    if (labelOptions.formatter !== undefined) {
      option.label.formatter = labelOptions.formatter
    }
    if (labelOptions.splitLineShow !== undefined) {
      for (let item in option.yAxis) {
        option.yAxis[item].splitLine = { show: labelOptions.axisLineShow }
      }
    }
    if (labelOptions.splitLineStyle !== undefined) {
      for (let item in option.yAxis) {
        option.yAxis[item].splitLine = {
          lineStyle: labelOptions.splitLineStyle
        }
      }
    }
    if (labelOptions.axisLabelFormatter !== undefined) {
      if (Array.isArray(labelOptions.axisLabelFormatter)) {
        let i = 0
        for (let item in option.yAxis) {
          option.yAxis[item].axisLabel.formatter =
            labelOptions.axisLabelFormatter[i]
          i++
        }
      } else {
        option.yAxis[0].axisLabel.formatter = labelOptions.axisLabelFormatter
      }
    }
  }

  // 再一次修改option默认值
  for (var i in option.series) {
    var item = option.series[i]
    if (item.name.indexOf('%') !== -1) {
      let yAxisIndex = item.yAxisIndex
      if (!yAxisIndex) yAxisIndex = 0
      option.yAxis[yAxisIndex].axisLabel.formatter = '{value} %'
    }
    option.legend.data.push(item.name)
    if (item.type === 'bar') {
      item.barMaxWidth = 30
    }
  }
  if (labelOptions && labelOptions.dataZoom) {
    option.dataZoom[0].start = labelOptions.dataZoom[0]
    option.dataZoom[1].start = labelOptions.dataZoom[0]
    option.dataZoom[0].end = labelOptions.dataZoom[1]
    option.dataZoom[1].end = labelOptions.dataZoom[1]
  } else {
    if (option.series.length > 0) {
      var dataLength = option.series[0].data.length
      if (dataLength > 12) {
        var start = parseInt(((dataLength - 12) * 100) / dataLength)
        option.dataZoom[0].start = start
        option.dataZoom[1].start = start
      }
    }
  }
  myChart.setOption(option)
}

function line(r, domId, domTitle, tooltipOptions, labelOptions) {
  var option = {
    color: colors,
    backgroundColor: {
      image: document.getElementById('waterMarkImg'),
      repeat: 'repeat'
    },
    title: {
      text: '',
      left: 'center',
      textStyle: {
        fontSize: 14
      }
    },
    legend: {
      data: [],
      bottom: 42
    },
    tooltip: {
      trigger: 'axis',
      textStyle: {
        fontSize: 12
      }
    },
    grid: {
      left: '3%',
      right: '4%',
      top: 40,
      bottom: '12%',
      containLabel: true
    },
    xAxis: [
      {
        type: 'category',
        data: [],
        axisPointer: {
          type: 'shadow'
        },
        axisLabel: {
          rotate: 70
        }
      }
    ],
    yAxis: [
      {
        type: 'value',
        name: '',
        axisLabel: {
          formatter: '{value}'
        }
      }
    ],
    label: {
      show: true,
      position: 'top',
      textStyle: {
        fontSize: 12
      }
    },
    series: [],
    dataZoom: [
      { show: true, realtime: true, start: 0, end: 100 },
      { type: 'inside', realtime: true, start: 0, end: 100 }
    ]
  }

  option.title.text = domTitle
  option.series = r.series
  option.xAxis[0].data = r.xAxis
  var myChart1 = echarts.getInstanceByDom(document.getElementById(domId))
  if (myChart1) myChart1.dispose()
  var myChart = echarts.init(document.getElementById(domId))

  if (tooltipOptions) {
    option.tooltip.formatter = tooltipOptions.formatter
  }
  if (labelOptions) {
    if (labelOptions.show !== undefined) {
      option.label.show = labelOptions.show
      if (!labelOptions.show) {
        for (let item in r.series) {
          r.series[item].symbol = 'none'
        }
      }
    }
    if (labelOptions.formatter !== undefined) {
      option.label.formatter = labelOptions.formatter
    }
    if (labelOptions.splitLineShow !== undefined) {
      for (let item in option.yAxis) {
        option.yAxis[item].splitLine = { show: labelOptions.axisLineShow }
      }
    }
    if (labelOptions.splitLineStyle !== undefined) {
      for (let item in option.yAxis) {
        option.yAxis[item].splitLine = {
          lineStyle: labelOptions.splitLineStyle
        }
      }
    }
    if (labelOptions.axisLabelFormatter !== undefined) {
      if (Array.isArray(labelOptions.axisLabelFormatter)) {
        let i = 0
        for (let item in option.yAxis) {
          option.yAxis[item].axisLabel.formatter =
            labelOptions.axisLabelFormatter[i]
          i++
        }
      } else {
        option.yAxis[0].axisLabel.formatter = labelOptions.axisLabelFormatter
      }
    }
  }

  // 再一次修改option默认值
  for (var i in option.series) {
    var item = option.series[i]
    if (item.name.indexOf('%') !== -1) {
      let yAxisIndex = item.yAxisIndex
      if (!yAxisIndex) yAxisIndex = 0
      option.yAxis[yAxisIndex].axisLabel.formatter = '{value} %'
    }
    option.legend.data.push(item.name)
    if (item.type === 'bar') {
      item.barMaxWidth = 30
    }
  }
  if (labelOptions && labelOptions.dataZoom) {
    option.dataZoom[0].start = labelOptions.dataZoom[0]
    option.dataZoom[1].start = labelOptions.dataZoom[0]
    option.dataZoom[0].end = labelOptions.dataZoom[1]
    option.dataZoom[1].end = labelOptions.dataZoom[1]
  } else {
    if (option.series.length > 0) {
      var dataLength = option.series[0].data.length
      if (dataLength > 12) {
        var start = parseInt(((dataLength - 12) * 100) / dataLength)
        option.dataZoom[0].start = start
        option.dataZoom[1].start = start
      }
    }
  }
  myChart.setOption(option)
}

function bar(r, domId, domTitle, tooltipOptions, labelOptions) {
  var option = {
    color: colors,
    backgroundColor: {
      image: document.getElementById('waterMarkImg'),
      repeat: 'repeat'
    },
    title: {
      text: '',
      left: 'center',
      textStyle: {
        fontSize: 14
      }
    },
    legend: {
      data: [],
      bottom: 42
    },
    tooltip: {
      trigger: 'axis',
      textStyle: {
        fontSize: 12
      }
    },
    grid: {
      left: '3%',
      right: '4%',
      top: 40,
      bottom: '12%',
      containLabel: true
    },
    xAxis: [
      {
        type: 'category',
        data: [],
        axisPointer: {
          type: 'shadow'
        },
        axisLabel: {
          rotate: 70
        }
      }
    ],
    yAxis: [
      {
        type: 'value',
        name: '',
        axisLabel: {
          formatter: '{value}'
        }
      }
    ],
    label: {
      show: true,
      position: 'inside',
      textStyle: {
        fontSize: 12
      }
    },
    series: [],
    dataZoom: [
      { show: true, realtime: true, start: 0, end: 100 },
      { type: 'inside', realtime: true, start: 0, end: 100 }
    ]
  }

  option.title.text = domTitle
  option.series = r.series
  option.xAxis[0].data = r.xAxis
  var myChart1 = echarts.getInstanceByDom(document.getElementById(domId))
  if (myChart1) myChart1.dispose()
  var myChart = echarts.init(document.getElementById(domId))

  if (tooltipOptions) {
    option.tooltip.formatter = tooltipOptions.formatter
  }
  if (labelOptions) {
    if (labelOptions.show !== undefined) {
      option.label.show = labelOptions.show
      if (!labelOptions.show) {
        for (let item in r.series) {
          r.series[item].symbol = 'none'
        }
      }
    }
    if (labelOptions.formatter !== undefined) {
      option.label.formatter = labelOptions.formatter
    }
    if (labelOptions.splitLineShow !== undefined) {
      for (let item in option.yAxis) {
        option.yAxis[item].splitLine = { show: labelOptions.axisLineShow }
      }
    }
    if (labelOptions.splitLineStyle !== undefined) {
      for (let item in option.yAxis) {
        option.yAxis[item].splitLine = {
          lineStyle: labelOptions.splitLineStyle
        }
      }
    }
    if (labelOptions.axisLabelFormatter !== undefined) {
      if (Array.isArray(labelOptions.axisLabelFormatter)) {
        let i = 0
        for (let item in option.yAxis) {
          option.yAxis[item].axisLabel.formatter =
            labelOptions.axisLabelFormatter[i]
          i++
        }
      } else {
        option.yAxis[0].axisLabel.formatter = labelOptions.axisLabelFormatter
      }
    }
  }

  // 再一次修改option默认值
  for (var i in option.series) {
    var item = option.series[i]
    if (item.name.indexOf('%') !== -1) {
      let yAxisIndex = item.yAxisIndex
      if (!yAxisIndex) yAxisIndex = 0
      option.yAxis[yAxisIndex].axisLabel.formatter = '{value} %'
    }
    option.legend.data.push(item.name)
    if (item.type === 'bar') {
      item.barMaxWidth = 30
    }
  }
  if (labelOptions && labelOptions.dataZoom) {
    option.dataZoom[0].start = labelOptions.dataZoom[0]
    option.dataZoom[1].start = labelOptions.dataZoom[0]
    option.dataZoom[0].end = labelOptions.dataZoom[1]
    option.dataZoom[1].end = labelOptions.dataZoom[1]
  } else {
    if (option.series.length > 0) {
      var dataLength = option.series[0].data.length
      if (dataLength > 12) {
        var start = parseInt(((dataLength - 12) * 100) / dataLength)
        option.dataZoom[0].start = start
        option.dataZoom[1].start = start
      }
    }
  }
  myChart.setOption(option)
}

function barV(r, domId, domTitle, tooltipOptions, labelOptions) {
  var title = ''
  var option = {
    color: colors,
    backgroundColor: {
      image: document.getElementById('waterMarkImg'),
      repeat: 'repeat'
    },
    title: {
      text: title,
      left: 'center',
      textStyle: {
        fontSize: 14
      }
    },
    tooltip: {
      trigger: 'axis',
      textStyle: {
        fontSize: 12
      }
    },
    grid: {
      left: '3%',
      right: '6%',
      top: 40,
      bottom: '3%',
      containLabel: true
    },
    xAxis: {
      show: false
    },
    label: {
      show: true,
      position: 'right'
    },
    yAxis: {
      type: 'category',
      data: [],
      axisTick: false,
      axisLabel: {
        interval: 0 // 设置成 0 强制显示所有标签。
      }
    },
    series: [
      {
        name: '',
        type: 'bar',
        barWidth: 20,
        data: []
      }
    ]
  }

  option.yAxis.data = r.xAxis
  option.series[0].data = r.series[0].data
  option.title.text = domTitle
  document.getElementById(domId).style.height =
    r.series[0].data.length * 30 + 100 + 'px'

  if (tooltipOptions) {
    option.tooltip.formatter = tooltipOptions.formatter
  }
  if (labelOptions) {
    if (labelOptions.show !== undefined) {
      option.label.show = labelOptions.show
    }
    if (labelOptions.formatter !== undefined) {
      option.label.formatter = labelOptions.formatter
    }
  }

  var myChart1 = echarts.getInstanceByDom(document.getElementById(domId))
  if (myChart1) myChart1.dispose()
  var myChart = echarts.init(document.getElementById(domId))
  myChart.setOption(option)
}

function pie(r, domId, domTitle, tooltipOptions, labelOptions) {
  var option = {
    color: colors,
    backgroundColor: {
      image: document.getElementById('waterMarkImg'),
      repeat: 'repeat'
    },
    title: {
      text: '',
      left: 'center',
      textStyle: {
        fontSize: 14
      }
    },
    tooltip: {
      trigger: 'item',
      textStyle: {
        fontSize: 12
      }
    },
    label: {
      show: true,
      position: 'inner',
      formatter: '{b}\n{d}%'
    },
    series: [
      {
        name: '',
        type: 'pie',
        radius: ['35%', '60%'],
        // minAngle: 10,//最小角度
        startAngle: 270, // 起始角度
        avoidLabelOverlap: true,
        data: []
      }
    ]
  }

  if (tooltipOptions) {
    option.tooltip.formatter = tooltipOptions.formatter
  }
  if (labelOptions) {
    if (labelOptions.show !== undefined) {
      option.label.show = labelOptions.show
    }
    if (labelOptions.formatter !== undefined) {
      option.label.formatter = labelOptions.formatter
    }
  }

  option.title.text = domTitle
  option.series[0].data = r
  var myChart1 = echarts.getInstanceByDom(document.getElementById(domId))
  if (myChart1) myChart1.dispose()
  var myChart = echarts.init(document.getElementById(domId))
  myChart.setOption(option)
}

function tree(r, domId, domTitle, tooltipOptions, labelOptions, click) {
  var option = {
    type: 'tree',
    backgroundColor: {
      image: document.getElementById('waterMarkImg'),
      repeat: 'repeat'
    },
    series: [
      {
        type: 'tree',

        data: [],

        top: '1%',
        left: '7%',
        bottom: '1%',
        right: '20%',

        symbolSize: 12,
        roam:true,
        initialTreeDepth:10,//展开层级为一层

        label: {
          position: 'left',
          verticalAlign: 'middle',
          align: 'right',
          fontSize: 12
        },

        leaves: {
          label: {
            position: 'right',
            verticalAlign: 'middle',
            align: 'left'
          }
        }
      }
    ]
  }

  if (tooltipOptions) {
    option.tooltip.formatter = tooltipOptions.formatter
  }
  if (labelOptions) {
    if (labelOptions.show !== undefined) {
      option.label.show = labelOptions.show
    }
    if (labelOptions.formatter !== undefined) {
      option.label.formatter = labelOptions.formatter
    }
  }

  // option.title.text = domTitle
  option.series[0].data = r
  var myChart1 = echarts.getInstanceByDom(document.getElementById(domId))
  if (myChart1) myChart1.dispose()
  var myChart = echarts.init(document.getElementById(domId))
  myChart.setOption(option)
  myChart.on('click', click)
}

export default {
  lineBar,
  line,
  bar,
  barV,
  pie,
  tree
}



// WEBPACK FOOTER //
// ./src/chart/chart.js